import { useState, useEffect } from 'react';

export function useSession() {
  const getSessionData = () => ({
    loggedInUsername: sessionStorage.getItem('loggedInUsername'),
    nombreEmpresa: sessionStorage.getItem('EmpresaNombre'),
    idEmpresa: sessionStorage.getItem('EmpresaId'),
    idPerfil: sessionStorage.getItem('PerfilID'),
    usuarioId: sessionStorage.getItem('UsuarioId'),
    // Elimina las comillas si las hubiera
    nombrePerfil: sessionStorage.getItem('PerfilNombre')?.replace(/^"|"$/g, ''),
  });

  const [sessionData, setSessionData] = useState(getSessionData());

  useEffect(() => {
    const handleStorageChange = () => {
      setSessionData(getSessionData());
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return sessionData;
}